<div class="page-bg font-sans" id="search-page-root">

  <!-- ── Loading overlay ───────────────────────────── -->
  <div class="loader-overlay" *ngIf="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- ── Saved Filters Slide-Over Panel ──────────────── -->
  <div *ngIf="isSavedFiltersPanelOpen" class="fixed inset-0 z-50 flex justify-end"
    (click)="isSavedFiltersPanelOpen = false">
    <div class="absolute inset-0 bg-black/30 backdrop-blur-sm"></div>
    <div class="relative w-full max-w-sm bg-white shadow-2xl h-full flex flex-col overflow-hidden"
      (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="flex items-center justify-between px-5 py-4 border-b border-gray-100" style="background: #fdf8f8;">
        <div class="flex items-center gap-2" style="color: #B01E3E;">
          <span class="material-symbols-outlined text-xl fill-icon">collections_bookmark</span>
          <h2 class="font-display text-base font-bold m-0">Saved Filters</h2>
          <span *ngIf="savedFilters.length > 0" class="text-[10px] font-bold px-2 py-0.5 rounded-full text-white"
            style="background: #B01E3E;">{{ savedFilters.length }}</span>
        </div>
        <button (click)="isSavedFiltersPanelOpen = false"
          class="h-8 w-8 rounded-full hover:bg-gray-100 flex items-center justify-center border-0 bg-transparent text-gray-400 transition-colors">
          <span class="material-symbols-outlined text-lg">close</span>
        </button>
      </div>
      <!-- Body -->
      <div class="flex-1 overflow-y-auto px-4 py-4 space-y-3">
        <div *ngIf="loadingSavedFilters" class="flex flex-col items-center justify-center py-12 text-gray-400">
          <span class="material-symbols-outlined text-3xl animate-spin mb-2">autorenew</span>
          <p class="text-xs">Loading saved filters…</p>
        </div>
        <div *ngIf="!loadingSavedFilters && savedFilters.length === 0"
          class="flex flex-col items-center justify-center py-12 text-center text-gray-400 gap-2">
          <div class="h-14 w-14 rounded-full flex items-center justify-center mb-1" style="background: #fdf0f3;">
            <span class="material-symbols-outlined text-2xl" style="color: #B01E3E;">bookmark_add</span>
          </div>
          <p class="text-sm font-semibold text-gray-700">No saved filters yet</p>
          <p class="text-xs leading-relaxed max-w-[200px]">
            Set your search criteria and click <strong>Save Filter</strong> to create a preset.
          </p>
        </div>
        <div *ngFor="let sf of savedFilters" class="rounded-2xl border transition-all" [ngClass]="sf._id === activeSavedFilterId
            ? 'border-emerald-300 bg-emerald-50 shadow-sm'
            : 'border-gray-100 bg-white hover:border-rose-100 hover:shadow-sm'">
          <div class="p-3.5">
            <div class="flex items-center justify-between mb-1">
              <div class="flex items-center gap-1.5 min-w-0">
                <span class="material-symbols-outlined text-[16px] fill-icon flex-shrink-0"
                  style="color:#B01E3E;">bookmark</span>
                <span class="font-semibold text-sm text-gray-800 truncate">{{ sf.filter_name }}</span>
                <span *ngIf="sf._id === activeSavedFilterId"
                  class="flex-shrink-0 text-[10px] font-bold text-emerald-700 bg-emerald-100 px-1.5 py-0.5 rounded-full">Active</span>
              </div>
            </div>
            <p class="text-[11px] text-gray-400 mb-3 leading-relaxed">{{ getSavedFilterSummary(sf) }}</p>
            <div class="flex items-center gap-2">
              <button (click)="applySavedFilter(sf)"
                class="flex-1 py-1.5 text-white text-xs font-semibold rounded-xl flex items-center justify-center gap-1 transition-colors border-0"
                style="background: #B01E3E;">
                <span class="material-symbols-outlined text-[14px]">play_arrow</span>
                Apply
              </button>
              <button (click)="editSavedFilter(sf)"
                class="h-8 w-8 rounded-xl border border-gray-100 flex items-center justify-center text-gray-400 hover:text-gray-700 hover:bg-gray-50 transition-colors bg-transparent">
                <span class="material-symbols-outlined text-[16px]">edit</span>
              </button>
              <button (click)="deleteSavedFilter(sf._id)"
                class="h-8 w-8 rounded-xl border border-rose-100 flex items-center justify-center text-rose-400 hover:bg-rose-50 hover:border-rose-200 transition-colors bg-transparent">
                <span class="material-symbols-outlined text-[16px]">delete</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <div class="px-4 py-4 border-t border-gray-100 bg-white">
        <button (click)="isSavedFiltersPanelOpen = false; openSaveFilterPopup()"
          class="w-full py-2.5 border-2 border-dashed rounded-xl text-xs font-semibold flex items-center justify-center gap-2 hover:bg-rose-50 transition-all bg-transparent"
          style="border-color: rgba(176,30,62,0.3); color: #B01E3E;">
          <span class="material-symbols-outlined text-[16px]">add</span>
          Save Current Search as Filter
        </button>
      </div>
    </div>
  </div>

  <!-- ── Save Filter Name Popup ───────────────────────── -->
  <div *ngIf="isSaveFilterPopupOpen" class="fixed inset-0 z-50 flex items-center justify-center"
    (click)="closeSaveFilterPopup()">
    <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
    <div class="relative bg-white rounded-3xl shadow-2xl p-6 w-full max-w-sm mx-4 border"
      style="border-color: rgba(176,30,62,0.15);" (click)="$event.stopPropagation()">
      <h3 class="font-display font-bold text-base m-0 mb-1" style="color: #B01E3E;">Save Current Filter</h3>
      <p class="text-xs text-gray-400 mb-4">Give this search a name so you can reuse it later.</p>
      <input [(ngModel)]="filterName" (keyup.enter)="submitFilterName()" type="text"
        placeholder="e.g. Chennai Hindu Brides"
        class="w-full rounded-xl border border-gray-200 px-4 py-2.5 text-sm outline-none transition-all mb-4"
        style="focus-outline-color: #B01E3E;" id="filter-name-input" />
      <div class="flex gap-3">
        <button (click)="closeSaveFilterPopup()"
          class="flex-1 py-2.5 border border-gray-200 rounded-xl text-xs font-semibold text-gray-500 hover:bg-gray-50 transition-colors bg-transparent">
          Cancel
        </button>
        <button (click)="submitFilterName()"
          class="flex-1 py-2.5 text-white rounded-xl text-xs font-semibold transition-colors border-0"
          style="background: #B01E3E;">
          <span class="material-symbols-outlined text-[14px] align-middle mr-1">bookmark</span>
          Save Filter
        </button>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════════ -->
  <!-- MAIN CONTENT                               -->
  <!-- ═══════════════════════════════════════════ -->
  <div class="max-w-[1400px] mx-auto px-5 sm:px-7 lg:px-10 py-5 space-y-4">

    <!-- ── Page Header ───────────────────────────── -->
    <header class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div>
  <div class="flex items-center gap-3">
    
    <button
      type="button"
      class="widowed-back-btn"
      (click)="goBack()"
      aria-label="Go back">
      <span class="material-symbols-outlined">arrow_back</span>
    </button>

    <h1
      class="font-display text-2xl sm:text-3xl font-bold tracking-tight m-0"
      style="color: #B01E3E;">
      Discover Matches
    </h1>

  </div>

  <p class="text-sm m-0 mt-1" style="color: #8c4458;">
    Find profiles that align with your preferences

    <span
      *ngIf="!loading && filteredMatches.length > 0"
      class="ml-2 text-[11px] font-bold px-2 py-0.5 rounded-full text-white"
      style="background: #B01E3E;">
      {{ filteredMatches.length }} Found
    </span>
  </p>
</div>
      <div class="flex items-center gap-2.5">
        <button *ngIf="!isFreePlan" (click)="toggleSavedFiltersPanel()"
          class="px-4 py-2 rounded-xl text-xs font-semibold flex items-center gap-2 border transition-all cursor-pointer"
          [ngStyle]="isSavedFiltersPanelOpen
            ? {'background': '#B01E3E', 'color': 'white', 'border-color': '#B01E3E'}
            : {'background': 'white', 'color': '#B01E3E', 'border-color': 'rgba(176,30,62,0.25)'}">
          <span class="material-symbols-outlined text-[18px]">collections_bookmark</span>
          Saved Filters
          <span *ngIf="savedFilters.length > 0" class="text-[10px] font-bold px-1.5 py-0.5 rounded-full"
            [ngStyle]="isSavedFiltersPanelOpen ? {'background': 'rgba(255,255,255,0.3)', 'color': 'white'} : {'background': '#B01E3E', 'color': 'white'}">
            {{ savedFilters.length }}
          </span>
        </button>
        <button *ngIf="isFreePlan" (click)="openSaveFilterPopup()"
          class="px-4 py-2 text-white rounded-xl text-xs font-bold shadow-sm transition-all border border-white/20 flex items-center gap-1.5 cursor-pointer hover:opacity-90"
          style="background: #B01E3E;">
          <span class="material-symbols-outlined text-[16px] text-white/80">lock</span>
          Saved Filters <span
            class="text-[9px] bg-white/20 text-white font-extrabold px-1.5 py-0.5 rounded tracking-wide ml-0.5">PRO</span>
        </button>
      </div>
    </header>

    <!-- ── Filter Bar ─────────────────────────────── -->
    <div class="bg-white rounded-2xl border shadow-sm overflow-visible" style="border-color: rgba(176,30,62,0.12);">

      <!-- Collapsed Toggle Row -->
      <div class="flex items-center gap-2 px-3 sm:px-5 py-3.5">

  <!-- Filter Toggle -->
  <button
    (click)="isFilterCollapsed = !isFilterCollapsed"
    class="flex items-center gap-2 px-3 sm:px-4 py-2 rounded-xl text-xs font-semibold border transition-all flex-shrink-0"
    [ngStyle]="!isFilterCollapsed
      ? {
          'background': '#B01E3E',
          'color': 'white',
          'border-color': '#B01E3E'
        }
      : {
          'background': '#fdf0f3',
          'color': '#B01E3E',
          'border-color': 'rgba(176,30,62,0.2)'
        }">

    <span class="material-symbols-outlined text-[16px]">tune</span>

    <span class="hidden sm:inline">Filters</span>

    <span
      *ngIf="getActiveFilterCount() > 0"
      class="text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
      [ngStyle]="!isFilterCollapsed
        ? {
            'background': 'rgba(255,255,255,0.3)',
            'color': 'white'
          }
        : {
            'background': '#B01E3E',
            'color': 'white'
          }">
      {{ getActiveFilterCount() }}
    </span>
  </button>


  <!-- Active Filter Chips -->
  <div
    class="flex items-center gap-1.5 flex-1 min-w-0 overflow-x-auto scrollbar-hide py-0.5">

    <button
      *ngFor="let chip of getActiveFilterChips()"
      type="button"
      (click)="onFilterChipClick(chip)"
      [title]="'Click to edit ' + chip.label"
      class="inline-flex items-center gap-1 font-medium rounded-full cursor-pointer transition-all border border-transparent hover:border-rose-300 hover:bg-rose-100/70 flex-shrink-0 whitespace-nowrap"
      style="
        background: rgba(176,30,62,0.08);
        color: #B01E3E;
        font-size: 11.5px;
        line-height: 16px;
        padding: 4px 10px;
      ">

      <span
        class="material-symbols-outlined"
        style="font-size: 12.5px;">
        edit
      </span>

      <span>{{ chip.label }}</span>

    </button>


    <!-- No filters -->
    <span
      *ngIf="getActiveFilterChips().length === 0"
      class="text-xs text-gray-400 whitespace-nowrap">
      No filters active
    </span>

  </div>


  <!-- Reset -->
  <button
    *ngIf="getActiveFilterCount() > 0"
    (click)="resetFilters()"
    class="text-xs font-semibold px-2.5 sm:px-3 py-1.5 rounded-lg border transition-all bg-transparent flex-shrink-0 whitespace-nowrap"
    style="
      border-color: rgba(176,30,62,0.2);
      color: #8c4458;
    ">
    Reset
    <span class="hidden sm:inline"> All</span>
  </button>

</div>

      <!-- Expandable Filter Panel -->
      <div [class.hidden]="isFilterCollapsed" class="border-t" style="border-color: rgba(176,30,62,0.08);">

        <!-- Tab Navigation -->
        <div class="flex overflow-x-auto border-b px-2 pt-1"
          style="background: #fdf8f9; border-color: rgba(176,30,62,0.08);">
          <button (click)="setTab('basic')" class="px-4 py-2.5 text-xs whitespace-nowrap transition-colors"
            [ngClass]="activeTab === 'basic' ? 'border-b-[3px] font-bold' : 'border-transparent font-medium text-gray-400'"
            [ngStyle]="activeTab === 'basic' ? {'border-color': '#B01E3E', 'color': '#B01E3E'} : {}">
            Basic Criteria
          </button>
          <button (click)="setTab('faith')" class="px-4 py-2.5 text-xs whitespace-nowrap transition-colors"
            [ngClass]="activeTab === 'faith' ? 'border-b-[3px] font-bold' : 'border-transparent font-medium text-gray-400'"
            [ngStyle]="activeTab === 'faith' ? {'border-color': '#B01E3E', 'color': '#B01E3E'} : {}">
            Religion / Caste
          </button>
          <button (click)="setTab('education')" class="px-4 py-2.5 text-xs whitespace-nowrap transition-colors"
            [ngClass]="activeTab === 'education' ? 'border-b-[3px] font-bold' : 'border-transparent font-medium text-gray-400'"
            [ngStyle]="activeTab === 'education' ? {'border-color': '#B01E3E', 'color': '#B01E3E'} : {}">
            Education
          </button>
          <button (click)="setTab('career')" class="px-4 py-2.5 text-xs whitespace-nowrap transition-colors"
            [ngClass]="activeTab === 'career' ? 'border-b-[3px] font-bold' : 'border-transparent font-medium text-gray-400'"
            [ngStyle]="activeTab === 'career' ? {'border-color': '#B01E3E', 'color': '#B01E3E'} : {}">
            Career / Income
          </button>
          <button (click)="setTab('location')" class="px-4 py-2.5 text-xs whitespace-nowrap transition-colors"
            [ngClass]="activeTab === 'location' ? 'border-b-[3px] font-bold' : 'border-transparent font-medium text-gray-400'"
            [ngStyle]="activeTab === 'location' ? {'border-color': '#B01E3E', 'color': '#B01E3E'} : {}">
            Location
          </button>
          <button (click)="setTab('lifestyle')" class="px-4 py-2.5 text-xs whitespace-nowrap transition-colors"
            [ngClass]="activeTab === 'lifestyle' ? 'border-b-[3px] font-bold' : 'border-transparent font-medium text-gray-400'"
            [ngStyle]="activeTab === 'lifestyle' ? {'border-color': '#B01E3E', 'color': '#B01E3E'} : {}">
            Lifestyle
          </button>
          <button (click)="setTab('horoscope')" class="px-4 py-2.5 text-xs whitespace-nowrap transition-colors"
            [ngClass]="activeTab === 'horoscope' ? 'border-b-[3px] font-bold' : 'border-transparent font-medium text-gray-400'"
            [ngStyle]="activeTab === 'horoscope' ? {'border-color': '#B01E3E', 'color': '#B01E3E'} : {}">
            Stars / Horoscope
          </button>
        </div>

        <!-- Filter Fields -->
        <form [formGroup]="formGroup" (submit)="$event.preventDefault(); applyFilter()">
          <div class="p-5 bg-white">

            <!-- Basic Criteria -->
            <div *ngIf="activeTab === 'basic'"
              class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-5 gap-y-4 pb-2">
              <!-- Marital Status -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Marital Status</label>
                <button type="button" (click)="toggleFilterDropdown('marital', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate pr-1 block"
                    [ngClass]="formGroup.value.marital ? 'font-semibold text-rose-950' : 'text-gray-500'">
                    {{ getSingleSelectLabel('marital', 'Any Status') }}
                  </span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'marital'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'marital'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto transition-all"
                  [ngClass]="dropdownDirection['marital'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div (click)="setSingleSelect('marital', '')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer transition-colors flex items-center justify-between"
                    [ngClass]="!formGroup.value.marital ? 'bg-rose-100/80 font-bold text-rose-950' : 'text-gray-700 hover:bg-rose-50'">
                    <span>Any Status</span><span *ngIf="!formGroup.value.marital"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <div
                    *ngFor="let status of ['Never Married', 'Widowed', 'Divorced']"
                    (click)="setSingleSelect('marital', status)"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer transition-colors flex items-center justify-between"
                    [ngClass]="formGroup.value.marital === status ? 'bg-rose-100/80 font-bold text-rose-950' : 'text-gray-700 hover:bg-rose-50'">
                    <span>{{ status }}</span><span *ngIf="formGroup.value.marital === status"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                </div>
              </div>

              <!-- Age Range -->
              <div>
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider" style="color: #8c4458;">Age
                  Range</label>
                <div class="flex items-center gap-1.5">
                  <div class="flex-1 relative searchable-multi-select-container">
                    <button type="button" (click)="toggleFilterDropdown('agefrom', $event)"
                      class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-2.5 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                      <span class="truncate block pr-1"
                        [ngClass]="formGroup.value.agefrom ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                        getSingleSelectLabel('agefrom', 'Min') }}</span>
                      <span class="material-symbols-outlined text-gray-500 text-[14px] flex-shrink-0">expand_more</span>
                    </button>
                    <div *ngIf="activeDropdown === 'agefrom'"
                      class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                      [ngClass]="dropdownDirection['agefrom'] === 'up' ? 'bottom-full mb-1' : 'top-full mt-1'">
                      <div (click)="setSingleSelect('agefrom', '')"
                        class="px-2.5 py-1.5 rounded-lg text-xs cursor-pointer"
                        [ngClass]="!formGroup.value.agefrom ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                        Min</div>
                      <div *ngFor="let age of ageFromValues" (click)="setSingleSelect('agefrom', age)"
                        class="px-2.5 py-1.5 rounded-lg text-xs cursor-pointer"
                        [ngClass]="formGroup.value.agefrom == age ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                        {{ age }} yrs</div>
                    </div>
                  </div>
                  <span class="text-gray-400 text-xs flex-shrink-0">–</span>
                  <div class="flex-1 relative searchable-multi-select-container">
                    <button type="button" (click)="toggleFilterDropdown('ageto', $event)"
                      class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-2.5 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                      <span class="truncate block pr-1"
                        [ngClass]="formGroup.value.ageto ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                        getSingleSelectLabel('ageto', 'Max') }}</span>
                      <span class="material-symbols-outlined text-gray-500 text-[14px] flex-shrink-0">expand_more</span>
                    </button>
                    <div *ngIf="activeDropdown === 'ageto'"
                      class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                      [ngClass]="dropdownDirection['ageto'] === 'up' ? 'bottom-full mb-1' : 'top-full mt-1'">
                      <div (click)="setSingleSelect('ageto', '')"
                        class="px-2.5 py-1.5 rounded-lg text-xs cursor-pointer"
                        [ngClass]="!formGroup.value.ageto ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                        Max</div>
                      <div *ngFor="let age of ageToValues" (click)="setSingleSelect('ageto', age)"
                        class="px-2.5 py-1.5 rounded-lg text-xs cursor-pointer"
                        [ngClass]="formGroup.value.ageto == age ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                        {{ age }} yrs</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Height Range -->
              <div>
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Height (cm)</label>
                <div class="flex items-center gap-1.5">
                  <div class="flex-1 relative searchable-multi-select-container">
                    <button type="button" (click)="toggleFilterDropdown('heightfrom', $event)"
                      class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-2.5 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                      <span class="truncate block pr-1"
                        [ngClass]="formGroup.value.heightfrom ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                        getSingleSelectLabel('heightfrom', 'Min') }}</span>
                      <span class="material-symbols-outlined text-gray-500 text-[14px] flex-shrink-0">expand_more</span>
                    </button>
                    <div *ngIf="activeDropdown === 'heightfrom'"
                      class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                      [ngClass]="dropdownDirection['heightfrom'] === 'up' ? 'bottom-full mb-1' : 'top-full mt-1'">
                      <div (click)="setSingleSelect('heightfrom', '')"
                        class="px-2.5 py-1.5 rounded-lg text-xs cursor-pointer"
                        [ngClass]="!formGroup.value.heightfrom ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                        Min</div>
                      <div *ngFor="let h of heightFromValues" (click)="setSingleSelect('heightfrom', h)"
                        class="px-2.5 py-1.5 rounded-lg text-xs cursor-pointer"
                        [ngClass]="formGroup.value.heightfrom == h ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                        {{ h }} cm</div>
                    </div>
                  </div>
                  <span class="text-gray-400 text-xs flex-shrink-0">–</span>
                  <div class="flex-1 relative searchable-multi-select-container">
                    <button type="button" (click)="toggleFilterDropdown('heightto', $event)"
                      class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-2.5 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                      <span class="truncate block pr-1"
                        [ngClass]="formGroup.value.heightto ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                        getSingleSelectLabel('heightto', 'Max') }}</span>
                      <span class="material-symbols-outlined text-gray-500 text-[14px] flex-shrink-0">expand_more</span>
                    </button>
                    <div *ngIf="activeDropdown === 'heightto'"
                      class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                      [ngClass]="dropdownDirection['heightto'] === 'up' ? 'bottom-full mb-1' : 'top-full mt-1'">
                      <div (click)="setSingleSelect('heightto', '')"
                        class="px-2.5 py-1.5 rounded-lg text-xs cursor-pointer"
                        [ngClass]="!formGroup.value.heightto ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                        Max</div>
                      <div *ngFor="let h of heightToValues" (click)="setSingleSelect('heightto', h)"
                        class="px-2.5 py-1.5 rounded-lg text-xs cursor-pointer"
                        [ngClass]="formGroup.value.heightto == h ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                        {{ h }} cm</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Physical Status -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Physical Status</label>
                <button type="button" (click)="toggleFilterDropdown('physical', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="formGroup.value.physical ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getSingleSelectLabel('physical', 'Any Physical Status') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'physical'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'physical'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['physical'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div (click)="setSingleSelect('physical', '')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="!formGroup.value.physical ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any Physical Status</span><span *ngIf="!formGroup.value.physical"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <div *ngFor="let p of ['Normal', 'Physically Challenged']" (click)="setSingleSelect('physical', p)"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="formGroup.value.physical === p ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>{{ p }}</span><span *ngIf="formGroup.value.physical === p"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                </div>
              </div>

              <!-- Family Type -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Family Type</label>
                <button type="button" (click)="toggleFilterDropdown('familytype', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="formGroup.value.familytype ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getSingleSelectLabel('familytype', 'Any Family Type') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'familytype'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'familytype'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['familytype'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div (click)="setSingleSelect('familytype', '')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="!formGroup.value.familytype ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any Family Type</span><span *ngIf="!formGroup.value.familytype"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <div *ngFor="let ft of ['Nuclear', 'Joint', 'Orthodox', 'Traditional', 'Moderate', 'Liberal']"
                    (click)="setSingleSelect('familytype', ft)"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="formGroup.value.familytype === ft ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>{{ ft }}</span><span *ngIf="formGroup.value.familytype === ft"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Religion / Caste -->
            <div *ngIf="activeTab === 'faith'"
              class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-5 gap-y-4 pb-2">
              <!-- Religion -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Religion</label>
                <button type="button" (click)="toggleFilterDropdown('religion', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="(formGroup.value.religion && formGroup.value.religion.length > 0) ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getMultiSelectLabel('religion', 'Any Religion', religions, 'religion_nme') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'religion'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'religion'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['religion'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div class="sticky top-0 bg-white z-10 pb-1.5 mb-1 border-b border-gray-100">
                    <input type="text" [(ngModel)]="singleSearchQuery" [ngModelOptions]="{standalone: true}"
                      placeholder="Search religion..."
                      class="w-full px-2.5 py-1 rounded-lg border border-gray-200 text-xs bg-gray-50 focus:bg-white focus:outline-none focus:border-rose-400">
                  </div>
                  <div (click)="formGroup.get('religion')?.setValue([])"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="(!formGroup.value.religion || formGroup.value.religion.length === 0) ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any Religion</span><span *ngIf="!formGroup.value.religion || formGroup.value.religion.length === 0"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <ng-container *ngFor="let rel of religions">
                    <div
                      *ngIf="!singleSearchQuery || rel.religion_nme?.toLowerCase()?.includes(singleSearchQuery.toLowerCase())"
                      (click)="toggleMultiSelect('religion', rel._id)"
                      class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                      [ngClass]="isMultiSelected('religion', rel._id) ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                      <div class="flex items-center gap-2">
                        <input type="checkbox" [checked]="isMultiSelected('religion', rel._id)" class="rounded text-rose-600 focus:ring-rose-500 pointer-events-none" style="accent-color: #B01E3E;">
                        <span>{{ rel.religion_nme }}</span>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- Caste -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Caste</label>
                <button type="button" (click)="toggleFilterDropdown('caste', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="(formGroup.value.caste && formGroup.value.caste.length > 0) ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getMultiSelectLabel('caste', 'Any Caste', castes, 'caste_nme') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'caste'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'caste'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['caste'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div class="sticky top-0 bg-white z-10 pb-1.5 mb-1 border-b border-gray-100">
                    <input type="text" [(ngModel)]="singleSearchQuery" [ngModelOptions]="{standalone: true}"
                      placeholder="Search caste..."
                      class="w-full px-2.5 py-1 rounded-lg border border-gray-200 text-xs bg-gray-50 focus:bg-white focus:outline-none focus:border-rose-400">
                  </div>
                  <div (click)="formGroup.get('caste')?.setValue([])"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="(!formGroup.value.caste || formGroup.value.caste.length === 0) ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any Caste</span><span *ngIf="!formGroup.value.caste || formGroup.value.caste.length === 0"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <ng-container *ngFor="let caste of castes">
                    <div
                      *ngIf="!singleSearchQuery || caste.caste_nme?.toLowerCase()?.includes(singleSearchQuery.toLowerCase())"
                      (click)="toggleMultiSelect('caste', caste._id)"
                      class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                      [ngClass]="isMultiSelected('caste', caste._id) ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                      <div class="flex items-center gap-2">
                        <input type="checkbox" [checked]="isMultiSelected('caste', caste._id)" class="rounded text-rose-600 focus:ring-rose-500 pointer-events-none" style="accent-color: #B01E3E;">
                        <span>{{ caste.caste_nme }}</span>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- Sub-Caste -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Sub-Caste</label>
                <button type="button" (click)="toggleFilterDropdown('subcaste', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="(formGroup.value.subcaste && formGroup.value.subcaste.length > 0) ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getMultiSelectLabel('subcaste', 'Any Sub-Caste', subcastes, 'subcaste_nme') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'subcaste'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'subcaste'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['subcaste'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div class="sticky top-0 bg-white z-10 pb-1.5 mb-1 border-b border-gray-100">
                    <input type="text" [(ngModel)]="singleSearchQuery" [ngModelOptions]="{standalone: true}"
                      placeholder="Search sub-caste..."
                      class="w-full px-2.5 py-1 rounded-lg border border-gray-200 text-xs bg-gray-50 focus:bg-white focus:outline-none focus:border-rose-400">
                  </div>
                  <div (click)="formGroup.get('subcaste')?.setValue([])"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="(!formGroup.value.subcaste || formGroup.value.subcaste.length === 0) ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any Sub-Caste</span><span *ngIf="!formGroup.value.subcaste || formGroup.value.subcaste.length === 0"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <ng-container *ngFor="let sub of subcastes">
                    <div
                      *ngIf="!singleSearchQuery || sub.subcaste_nme?.toLowerCase()?.includes(singleSearchQuery.toLowerCase())"
                      (click)="toggleMultiSelect('subcaste', sub._id)"
                      class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                      [ngClass]="isMultiSelected('subcaste', sub._id) ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                      <div class="flex items-center gap-2">
                        <input type="checkbox" [checked]="isMultiSelected('subcaste', sub._id)" class="rounded text-rose-600 focus:ring-rose-500 pointer-events-none" style="accent-color: #B01E3E;">
                        <span>{{ sub.subcaste_nme }}</span>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- Mother Tongue -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Mother Tongue</label>
                <button type="button" (click)="toggleFilterDropdown('language', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="(formGroup.value.language && formGroup.value.language.length > 0) ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getMultiSelectLabel('language', 'Any Language', languages, 'language_nme') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'language'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'language'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['language'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div class="sticky top-0 bg-white z-10 pb-1.5 mb-1 border-b border-gray-100">
                    <input type="text" [(ngModel)]="singleSearchQuery" [ngModelOptions]="{standalone: true}"
                      placeholder="Search language..."
                      class="w-full px-2.5 py-1 rounded-lg border border-gray-200 text-xs bg-gray-50 focus:bg-white focus:outline-none focus:border-rose-400">
                  </div>
                  <div (click)="formGroup.get('language')?.setValue([])"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="(!formGroup.value.language || formGroup.value.language.length === 0) ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any Language</span><span *ngIf="!formGroup.value.language || formGroup.value.language.length === 0"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <ng-container *ngFor="let lang of languages">
                    <div
                      *ngIf="!singleSearchQuery || lang.language_nme?.toLowerCase()?.includes(singleSearchQuery.toLowerCase())"
                      (click)="toggleMultiSelect('language', lang._id)"
                      class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                      [ngClass]="isMultiSelected('language', lang._id) ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                      <div class="flex items-center gap-2">
                        <input type="checkbox" [checked]="isMultiSelected('language', lang._id)" class="rounded text-rose-600 focus:ring-rose-500 pointer-events-none" style="accent-color: #B01E3E;">
                        <span>{{ lang.language_nme }}</span>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>

            <!-- Education -->
            <div *ngIf="activeTab === 'education'" class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 pb-4">
              <!-- Highest Qualification Dropdown -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Highest Qualification</label>
                <!-- Dropdown Trigger Button -->
                <button type="button" (click)="toggleFilterDropdown('edu', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3.5 py-2.5 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-2"
                    [ngClass]="getSelectedEduCount() > 0 ? 'font-semibold text-rose-950' : 'text-gray-500'">
                    {{ getSelectedEduLabel() }}
                  </span>
                  <div class="flex items-center gap-1.5 flex-shrink-0">
                    <span *ngIf="getSelectedEduCount() > 0"
                      class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-rose-100 text-rose-800">{{
                      getSelectedEduCount() }}</span>
                    <span class="material-symbols-outlined text-gray-500 text-[18px] transition-transform duration-200"
                      [class.rotate-180]="activeDropdown === 'edu'">expand_more</span>
                  </div>
                </button>

                <!-- Dropdown Popover Menu -->
                <div *ngIf="activeDropdown === 'edu'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-3.5 transition-all"
                  [ngClass]="dropdownDirection['edu'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <!-- Sticky Search Box -->
                  <div class="sticky top-0 bg-white z-10 pb-2.5 border-b border-gray-100">
                    <div class="relative flex items-center">
                      <span
                        class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-[18px] pointer-events-none flex items-center justify-center">search</span>
                      <input type="text" [(ngModel)]="eduSearchQuery" [ngModelOptions]="{standalone: true}"
                        placeholder="Search degree (e.g. B.E., B.Tech, Arts)..."
                        class="w-full pl-10 pr-8 py-2 rounded-xl border border-gray-200 text-xs bg-gray-50/70 focus:bg-white focus:outline-none focus:border-rose-400 transition-colors">
                      <button *ngIf="eduSearchQuery" type="button" (click)="eduSearchQuery = ''"
                        class="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 flex items-center justify-center border-0 bg-transparent cursor-pointer p-0">
                        <span class="material-symbols-outlined text-[16px]">close</span>
                      </button>
                    </div>
                  </div>
                  <!-- Scrollable Checkbox List -->
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-1 max-h-[220px] overflow-y-auto pr-1 pt-2.5"
                    formArrayName="education">
                    <ng-container *ngFor="let edu of educations; let i = index">
                      <label
                        *ngIf="!eduSearchQuery || edu.education_nme?.toLowerCase()?.includes(eduSearchQuery.toLowerCase())"
                        class="flex items-center gap-2.5 px-2.5 py-2 hover:bg-rose-50 rounded-xl cursor-pointer text-xs text-gray-700 transition-colors select-none"
                        [ngClass]="{'bg-rose-100/80 font-semibold text-rose-950': formGroup.value.education[i]}">
                        <input type="checkbox" [formControlName]="i"
                          class="rounded w-4 h-4 flex-shrink-0 cursor-pointer" style="accent-color: #B01E3E;">
                        <span class="truncate" [title]="edu.education_nme">{{ edu.education_nme }}</span>
                      </label>
                    </ng-container>
                  </div>
                  <!-- Footer -->
                  <div class="flex items-center justify-between border-t border-gray-100 mt-2.5 pt-2.5 px-1">
                    <span class="text-[11px] text-gray-500 font-medium">{{ getSelectedEduCount() }} selected</span>
                    <button type="button" (click)="activeDropdown = null"
                      class="px-4 py-1.5 rounded-lg text-xs font-bold text-white shadow-sm border-0 cursor-pointer hover:opacity-90 transition-opacity"
                      style="background: #B01E3E;">
                      Done
                    </button>
                  </div>
                </div>
              </div>

              <!-- Higher / Postgraduate Dropdown -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Higher / Postgraduate</label>
                <!-- Dropdown Trigger Button -->
                <button type="button" (click)="toggleFilterDropdown('higheredu', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3.5 py-2.5 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-2"
                    [ngClass]="getSelectedHigherEduCount() > 0 ? 'font-semibold text-rose-950' : 'text-gray-500'">
                    {{ getSelectedHigherEduLabel() }}
                  </span>
                  <div class="flex items-center gap-1.5 flex-shrink-0">
                    <span *ngIf="getSelectedHigherEduCount() > 0"
                      class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-rose-100 text-rose-800">{{
                      getSelectedHigherEduCount() }}</span>
                    <span class="material-symbols-outlined text-gray-500 text-[18px] transition-transform duration-200"
                      [class.rotate-180]="activeDropdown === 'higheredu'">expand_more</span>
                  </div>
                </button>

                <!-- Dropdown Popover Menu -->
                <div *ngIf="activeDropdown === 'higheredu'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-3.5 transition-all"
                  [ngClass]="dropdownDirection['higheredu'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <!-- Sticky Search Box -->
                  <div class="sticky top-0 bg-white z-10 pb-2.5 border-b border-gray-100">
                    <div class="relative flex items-center">
                      <span
                        class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-[18px] pointer-events-none flex items-center justify-center">search</span>
                      <input type="text" [(ngModel)]="higherEduSearchQuery" [ngModelOptions]="{standalone: true}"
                        placeholder="Search master's/postgrad (e.g. MBA, M.Tech)..."
                        class="w-full pl-10 pr-8 py-2 rounded-xl border border-gray-200 text-xs bg-gray-50/70 focus:bg-white focus:outline-none focus:border-rose-400 transition-colors">
                      <button *ngIf="higherEduSearchQuery" type="button" (click)="higherEduSearchQuery = ''"
                        class="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 flex items-center justify-center border-0 bg-transparent cursor-pointer p-0">
                        <span class="material-symbols-outlined text-[16px]">close</span>
                      </button>
                    </div>
                  </div>
                  <!-- Scrollable Checkbox List -->
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-1 max-h-[220px] overflow-y-auto pr-1 pt-2.5"
                    formArrayName="highereducation">
                    <ng-container *ngFor="let edu of highereducations; let i = index">
                      <label
                        *ngIf="!higherEduSearchQuery || edu.highereducation_nme?.toLowerCase()?.includes(higherEduSearchQuery.toLowerCase())"
                        class="flex items-center gap-2.5 px-2.5 py-2 hover:bg-rose-50 rounded-xl cursor-pointer text-xs text-gray-700 transition-colors select-none"
                        [ngClass]="{'bg-rose-100/80 font-semibold text-rose-950': formGroup.value.highereducation[i]}">
                        <input type="checkbox" [formControlName]="i"
                          class="rounded w-4 h-4 flex-shrink-0 cursor-pointer" style="accent-color: #B01E3E;">
                        <span class="truncate" [title]="edu.highereducation_nme">{{ edu.highereducation_nme }}</span>
                      </label>
                    </ng-container>
                  </div>
                  <!-- Footer -->
                  <div class="flex items-center justify-between border-t border-gray-100 mt-2.5 pt-2.5 px-1">
                    <span class="text-[11px] text-gray-500 font-medium">{{ getSelectedHigherEduCount() }}
                      selected</span>
                    <button type="button" (click)="activeDropdown = null"
                      class="px-4 py-1.5 rounded-lg text-xs font-bold text-white shadow-sm border-0 cursor-pointer hover:opacity-90 transition-opacity"
                      style="background: #B01E3E;">
                      Done
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Career / Income -->
            <div *ngIf="activeTab === 'career'"
              class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-5 gap-y-4 pb-2">
              <!-- Employment Type -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Employment Type</label>
                <button type="button" (click)="toggleFilterDropdown('employmentype', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="(formGroup.value.employmentype && formGroup.value.employmentype.length > 0) ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getMultiSelectLabel('employmentype', 'Any Employment Type', employmentypes, 'employment_type_nme') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'employmentype'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'employmentype'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['employmentype'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div (click)="formGroup.get('employmentype')?.setValue([])"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="(!formGroup.value.employmentype || formGroup.value.employmentype.length === 0) ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any Employment Type</span><span *ngIf="!formGroup.value.employmentype || formGroup.value.employmentype.length === 0"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <ng-container *ngFor="let emp of employmentypes">
                    <div (click)="toggleMultiSelect('employmentype', emp._id)"
                      class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                      [ngClass]="isMultiSelected('employmentype', emp._id) ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                      <div class="flex items-center gap-2">
                        <input type="checkbox" [checked]="isMultiSelected('employmentype', emp._id)" class="rounded text-rose-600 focus:ring-rose-500 pointer-events-none" style="accent-color: #B01E3E;">
                        <span>{{ emp.employment_type_nme || emp.employment_name }}</span>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- Income Range (Multi-select) -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Income Brackets</label>
                <button type="button" (click)="toggleFilterDropdown('income', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="(formGroup.value.income && formGroup.value.income.length > 0) ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getMultiSelectLabel('income', 'Any Income Range', incomes, 'income_name') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'income'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'income'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['income'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div (click)="formGroup.get('income')?.setValue([])"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="(!formGroup.value.income || formGroup.value.income.length === 0) ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any Income Range</span><span *ngIf="!formGroup.value.income || formGroup.value.income.length === 0"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <ng-container *ngFor="let inc of incomes">
                    <div (click)="toggleMultiSelect('income', inc._id)"
                      class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                      [ngClass]="isMultiSelected('income', inc._id) ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                      <div class="flex items-center gap-2">
                        <input type="checkbox" [checked]="isMultiSelected('income', inc._id)" class="rounded text-rose-600 focus:ring-rose-500 pointer-events-none" style="accent-color: #B01E3E;">
                        <span>{{ inc.income_name || inc.income_nme || inc.income }}</span>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- Occupation (Multi-select) -->
              <div class="md:col-span-2 relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Occupation</label>
                <!-- Dropdown Trigger Button -->
                <button type="button" (click)="toggleFilterDropdown('occ', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3.5 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-2"
                    [ngClass]="getSelectedOccCount() > 0 ? 'font-semibold text-rose-950' : 'text-gray-500'">
                    {{ getSelectedOccLabel() }}
                  </span>
                  <div class="flex items-center gap-1.5 flex-shrink-0">
                    <span *ngIf="getSelectedOccCount() > 0"
                      class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-rose-100 text-rose-800">{{
                      getSelectedOccCount() }}</span>
                    <span class="material-symbols-outlined text-gray-500 text-[18px] transition-transform duration-200"
                      [class.rotate-180]="activeDropdown === 'occ'">expand_more</span>
                  </div>
                </button>

                <!-- Dropdown Popover Menu -->
                <div *ngIf="activeDropdown === 'occ'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-3.5 transition-all"
                  [ngClass]="dropdownDirection['occ'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <!-- Sticky Search Box -->
                  <div class="sticky top-0 bg-white z-10 pb-2.5 border-b border-gray-100">
                    <div class="relative flex items-center">
                      <span
                        class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-[18px] pointer-events-none flex items-center justify-center">search</span>
                      <input type="text" [(ngModel)]="occSearchQuery" [ngModelOptions]="{standalone: true}"
                        placeholder="Search occupation (e.g. Software Engineer, Doctor)..."
                        class="w-full pl-10 pr-8 py-2 rounded-xl border border-gray-200 text-xs bg-gray-50/70 focus:bg-white focus:outline-none focus:border-rose-400 transition-colors">
                      <button *ngIf="occSearchQuery" type="button" (click)="occSearchQuery = ''"
                        class="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 flex items-center justify-center border-0 bg-transparent cursor-pointer p-0">
                        <span class="material-symbols-outlined text-[16px]">close</span>
                      </button>
                    </div>
                  </div>
                  <!-- Scrollable Checkbox List -->
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-1 max-h-[220px] overflow-y-auto pr-1 pt-2.5">
                    <ng-container *ngFor="let occ of occupations">
                      <label
                        *ngIf="!occSearchQuery || (occ.occupation_nme || occ.occupation_name || '')?.toLowerCase()?.includes(occSearchQuery.toLowerCase())"
                        class="flex items-center gap-2.5 px-2.5 py-2 hover:bg-rose-50 rounded-xl cursor-pointer text-xs text-gray-700 transition-colors select-none"
                        [ngClass]="{'bg-rose-100/80 font-semibold text-rose-950': isOccSelected(occ._id)}">
                        <input type="checkbox" [checked]="isOccSelected(occ._id)" (change)="toggleOccupation(occ._id)"
                          class="rounded w-4 h-4 flex-shrink-0 cursor-pointer" style="accent-color: #B01E3E;">
                        <span class="truncate" [title]="occ.occupation_nme || occ.occupation_name">{{ occ.occupation_nme
                          || occ.occupation_name }}</span>
                      </label>
                    </ng-container>
                  </div>
                  <!-- Footer -->
                  <div class="flex items-center justify-between border-t border-gray-100 mt-2.5 pt-2.5 px-1">
                    <span class="text-[11px] text-gray-500 font-medium">{{ getSelectedOccCount() }} selected</span>
                    <button type="button" (click)="activeDropdown = null"
                      class="px-4 py-1.5 rounded-lg text-xs font-bold text-white shadow-sm border-0 cursor-pointer hover:opacity-90 transition-opacity"
                      style="background: #B01E3E;">
                      Done
                    </button>
                  </div>
                </div>
              </div>

              <!-- Annual Salary Range (Exact ₹ Min/Max) -->
              <div class="col-span-1 sm:col-span-2 md:col-span-2">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Exact Salary Range (₹)</label>
                <div class="flex items-center gap-1.5">
                  <div class="flex-1 relative searchable-multi-select-container">
                    <button type="button" (click)="toggleFilterDropdown('salaryfrom', $event)"
                      class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-2.5 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                      <span class="truncate block pr-1"
                        [ngClass]="formGroup.value.salaryfrom ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                        getSingleSelectLabel('salaryfrom', 'Min') }}</span>
                      <span class="material-symbols-outlined text-gray-500 text-[14px] flex-shrink-0">expand_more</span>
                    </button>
                    <div *ngIf="activeDropdown === 'salaryfrom'"
                      class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                      [ngClass]="dropdownDirection['salaryfrom'] === 'up' ? 'bottom-full mb-1' : 'top-full mt-1'">
                      <div (click)="setSingleSelect('salaryfrom', '')"
                        class="px-2.5 py-1.5 rounded-lg text-xs cursor-pointer"
                        [ngClass]="!formGroup.value.salaryfrom ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                        Min</div>
                      <div *ngFor="let s of salaryFromValues" (click)="setSingleSelect('salaryfrom', s)"
                        class="px-2.5 py-1.5 rounded-lg text-xs cursor-pointer"
                        [ngClass]="formGroup.value.salaryfrom == s ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                        {{ (s/100000).toFixed(1) }}L</div>
                    </div>
                  </div>
                  <span class="text-gray-400 text-xs flex-shrink-0">–</span>
                  <div class="flex-1 relative searchable-multi-select-container">
                    <button type="button" (click)="toggleFilterDropdown('salaryto', $event)"
                      class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-2.5 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                      <span class="truncate block pr-1"
                        [ngClass]="formGroup.value.salaryto ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                        getSingleSelectLabel('salaryto', 'Max') }}</span>
                      <span class="material-symbols-outlined text-gray-500 text-[14px] flex-shrink-0">expand_more</span>
                    </button>
                    <div *ngIf="activeDropdown === 'salaryto'"
                      class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                      [ngClass]="dropdownDirection['salaryto'] === 'up' ? 'bottom-full mb-1' : 'top-full mt-1'">
                      <div (click)="setSingleSelect('salaryto', '')"
                        class="px-2.5 py-1.5 rounded-lg text-xs cursor-pointer"
                        [ngClass]="!formGroup.value.salaryto ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                        Max</div>
                      <div *ngFor="let s of salaryToValues" (click)="setSingleSelect('salaryto', s)"
                        class="px-2.5 py-1.5 rounded-lg text-xs cursor-pointer"
                        [ngClass]="formGroup.value.salaryto == s ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                        {{ (s/100000).toFixed(1) }}L</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Location -->
            <div *ngIf="activeTab === 'location'"
              class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-x-5 gap-y-4 pb-2">
              <!-- Country -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Country</label>
                <button type="button" (click)="toggleFilterDropdown('country', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="formGroup.value.country ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getSingleSelectLabel('country', 'Any Country') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'country'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'country'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['country'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div class="sticky top-0 bg-white z-10 pb-1.5 mb-1 border-b border-gray-100">
                    <input type="text" [(ngModel)]="singleSearchQuery" [ngModelOptions]="{standalone: true}"
                      placeholder="Search country..."
                      class="w-full px-2.5 py-1 rounded-lg border border-gray-200 text-xs bg-gray-50 focus:bg-white focus:outline-none focus:border-rose-400">
                  </div>
                  <div (click)="setSingleSelect('country', '')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="!formGroup.value.country ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any Country</span><span *ngIf="!formGroup.value.country"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <ng-container *ngFor="let cnty of countrys">
                    <div
                      *ngIf="!singleSearchQuery || (cnty.country_nme || cnty.name_0 || cnty.country_name || '')?.toLowerCase()?.includes(singleSearchQuery.toLowerCase())"
                      (click)="setSingleSelect('country', cnty._id)"
                      class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                      [ngClass]="formGroup.value.country === cnty._id ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                      <span>{{ cnty.country_nme || cnty.name_0 || cnty.country_name }}</span><span
                        *ngIf="formGroup.value.country === cnty._id"
                        class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- State -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">State</label>
                <button type="button" (click)="toggleFilterDropdown('state', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="formGroup.value.state ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getSingleSelectLabel('state', 'Any State') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'state'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'state'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['state'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div class="sticky top-0 bg-white z-10 pb-1.5 mb-1 border-b border-gray-100">
                    <input type="text" [(ngModel)]="singleSearchQuery" [ngModelOptions]="{standalone: true}"
                      placeholder="Search state..."
                      class="w-full px-2.5 py-1 rounded-lg border border-gray-200 text-xs bg-gray-50 focus:bg-white focus:outline-none focus:border-rose-400">
                  </div>
                  <div (click)="setSingleSelect('state', '')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="!formGroup.value.state ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any State</span><span *ngIf="!formGroup.value.state"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <ng-container *ngFor="let st of filteredStates">
                    <div
                      *ngIf="!singleSearchQuery || (st.name_1 || st.state_nme || '')?.toLowerCase()?.includes(singleSearchQuery.toLowerCase())"
                      (click)="setSingleSelect('state', st._id)"
                      class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                      [ngClass]="formGroup.value.state === st._id ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                      <span>{{ st.name_1 || st.state_nme }}</span><span *ngIf="formGroup.value.state === st._id"
                        class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- District -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">District</label>
                <button type="button" (click)="toggleFilterDropdown('district', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="formGroup.value.district ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getSingleSelectLabel('district', 'Any District') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'district'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'district'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['district'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div class="sticky top-0 bg-white z-10 pb-1.5 mb-1 border-b border-gray-100">
                    <input type="text" [(ngModel)]="singleSearchQuery" [ngModelOptions]="{standalone: true}"
                      placeholder="Search district..."
                      class="w-full px-2.5 py-1 rounded-lg border border-gray-200 text-xs bg-gray-50 focus:bg-white focus:outline-none focus:border-rose-400">
                  </div>
                  <div (click)="setSingleSelect('district', '')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="!formGroup.value.district ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any District</span><span *ngIf="!formGroup.value.district"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <ng-container *ngFor="let d of filteredDistricts">
                    <div
                      *ngIf="!singleSearchQuery || (d.name_2 || d.district_nme || '')?.toLowerCase()?.includes(singleSearchQuery.toLowerCase())"
                      (click)="setSingleSelect('district', d._id)"
                      class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                      [ngClass]="formGroup.value.district === d._id ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                      <span>{{ d.name_2 || d.district_nme }}</span><span *ngIf="formGroup.value.district === d._id"
                        class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- City -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">City</label>
                <button type="button" (click)="toggleFilterDropdown('city', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="formGroup.value.city ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getSingleSelectLabel('city', 'Any City') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'city'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'city'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['city'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div class="sticky top-0 bg-white z-10 pb-1.5 mb-1 border-b border-gray-100">
                    <input type="text" [(ngModel)]="singleSearchQuery" [ngModelOptions]="{standalone: true}"
                      placeholder="Search city..."
                      class="w-full px-2.5 py-1 rounded-lg border border-gray-200 text-xs bg-gray-50 focus:bg-white focus:outline-none focus:border-rose-400">
                  </div>
                  <div (click)="setSingleSelect('city', '')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="!formGroup.value.city ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any City</span><span *ngIf="!formGroup.value.city"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <ng-container *ngFor="let cty of filteredCities">
                    <div
                      *ngIf="!singleSearchQuery || (cty.city_nme || cty.city_name || '')?.toLowerCase()?.includes(singleSearchQuery.toLowerCase())"
                      (click)="setSingleSelect('city', cty._id)"
                      class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                      [ngClass]="formGroup.value.city === cty._id ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                      <span>{{ cty.city_nme || cty.city_name }}</span><span *ngIf="formGroup.value.city === cty._id"
                        class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- Citizenship -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Citizenship</label>
                <button type="button" (click)="toggleFilterDropdown('citizen', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="formGroup.value.citizen ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getSingleSelectLabel('citizen', 'Any') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'citizen'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'citizen'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['citizen'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div class="sticky top-0 bg-white z-10 pb-1.5 mb-1 border-b border-gray-100">
                    <input type="text" [(ngModel)]="singleSearchQuery" [ngModelOptions]="{standalone: true}"
                      placeholder="Search citizenship..."
                      class="w-full px-2.5 py-1 rounded-lg border border-gray-200 text-xs bg-gray-50 focus:bg-white focus:outline-none focus:border-rose-400">
                  </div>
                  <div (click)="setSingleSelect('citizen', '')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="!formGroup.value.citizen ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any</span><span *ngIf="!formGroup.value.citizen"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <ng-container *ngFor="let c of citizens">
                    <div
                      *ngIf="!singleSearchQuery || (c.citizenship_nme || '')?.toLowerCase()?.includes(singleSearchQuery.toLowerCase())"
                      (click)="setSingleSelect('citizen', c._id)"
                      class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                      [ngClass]="formGroup.value.citizen === c._id ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                      <span>{{ c.citizenship_nme }}</span><span *ngIf="formGroup.value.citizen === c._id"
                        class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>

            <!-- Lifestyle -->
            <div *ngIf="activeTab === 'lifestyle'" class="grid grid-cols-1 sm:grid-cols-3 gap-x-5 gap-y-4 pb-2">
              <!-- Diet -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Diet</label>
                <button type="button" (click)="toggleFilterDropdown('food', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="formGroup.value.food ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getSingleSelectLabel('food', 'Any') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'food'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'food'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['food'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div (click)="setSingleSelect('food', '')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="!formGroup.value.food ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any</span><span *ngIf="!formGroup.value.food"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <div *ngFor="let diet of ['Vegetarian', 'Non-vegetarian', 'Eggtarian']"
                    (click)="setSingleSelect('food', diet)"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="formGroup.value.food === diet ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>{{ diet }}</span><span *ngIf="formGroup.value.food === diet"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                </div>
              </div>

              <!-- Smoking -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Smoking</label>
                <button type="button" (click)="toggleFilterDropdown('smoking', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="formGroup.value.smoking ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getSingleSelectLabel('smoking', 'Any') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'smoking'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'smoking'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['smoking'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div (click)="setSingleSelect('smoking', '')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="!formGroup.value.smoking ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any</span><span *ngIf="!formGroup.value.smoking"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <div (click)="setSingleSelect('smoking', 'No')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="formGroup.value.smoking === 'No' ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Non-Smoker</span><span *ngIf="formGroup.value.smoking === 'No'"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <div (click)="setSingleSelect('smoking', 'Yes')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="formGroup.value.smoking === 'Yes' ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Smoker</span><span *ngIf="formGroup.value.smoking === 'Yes'"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                </div>
              </div>

              <!-- Drinking -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Drinking</label>
                <button type="button" (click)="toggleFilterDropdown('drinking', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="formGroup.value.drinking ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getSingleSelectLabel('drinking', 'Any') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'drinking'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'drinking'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['drinking'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div (click)="setSingleSelect('drinking', '')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="!formGroup.value.drinking ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any</span><span *ngIf="!formGroup.value.drinking"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <div (click)="setSingleSelect('drinking', 'No')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="formGroup.value.drinking === 'No' ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Non-Drinker</span><span *ngIf="formGroup.value.drinking === 'No'"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <div (click)="setSingleSelect('drinking', 'Yes')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="formGroup.value.drinking === 'Yes' ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Drinker</span><span *ngIf="formGroup.value.drinking === 'Yes'"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Horoscope -->
            <div *ngIf="activeTab === 'horoscope'"
              class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-5 gap-y-4 pb-2">
              <!-- Rasi / Zodiac -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider" style="color: #8c4458;">Rasi
                  / Zodiac</label>
                <button type="button" (click)="toggleFilterDropdown('rasi', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="formGroup.value.rasi ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getSingleSelectLabel('rasi', 'Any Rasi') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'rasi'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'rasi'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['rasi'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div class="sticky top-0 bg-white z-10 pb-1.5 mb-1 border-b border-gray-100">
                    <input type="text" [(ngModel)]="singleSearchQuery" [ngModelOptions]="{standalone: true}"
                      placeholder="Search rasi..."
                      class="w-full px-2.5 py-1 rounded-lg border border-gray-200 text-xs bg-gray-50 focus:bg-white focus:outline-none focus:border-rose-400">
                  </div>
                  <div (click)="setSingleSelect('rasi', '')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="!formGroup.value.rasi ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any Rasi</span><span *ngIf="!formGroup.value.rasi"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <ng-container *ngFor="let r of rasis">
                    <div
                      *ngIf="!singleSearchQuery || (r.rasi_nme || '')?.toLowerCase()?.includes(singleSearchQuery.toLowerCase())"
                      (click)="setSingleSelect('rasi', r._id)"
                      class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                      [ngClass]="formGroup.value.rasi === r._id ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                      <span>{{ r.rasi_nme }}</span><span *ngIf="formGroup.value.rasi === r._id"
                        class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- Natchatra / Star -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Natchatra / Star</label>
                <button type="button" (click)="toggleFilterDropdown('natchra', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="formGroup.value.natchra ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getSingleSelectLabel('natchra', 'Any Star') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'natchra'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'natchra'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['natchra'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div class="sticky top-0 bg-white z-10 pb-1.5 mb-1 border-b border-gray-100">
                    <input type="text" [(ngModel)]="singleSearchQuery" [ngModelOptions]="{standalone: true}"
                      placeholder="Search star..."
                      class="w-full px-2.5 py-1 rounded-lg border border-gray-200 text-xs bg-gray-50 focus:bg-white focus:outline-none focus:border-rose-400">
                  </div>
                  <div (click)="setSingleSelect('natchra', '')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="!formGroup.value.natchra ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any Star</span><span *ngIf="!formGroup.value.natchra"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <ng-container *ngFor="let n of natchatras">
                    <div
                      *ngIf="!singleSearchQuery || (n.natchr_nme || '')?.toLowerCase()?.includes(singleSearchQuery.toLowerCase())"
                      (click)="setSingleSelect('natchra', n._id)"
                      class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                      [ngClass]="formGroup.value.natchra === n._id ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                      <span>{{ n.natchr_nme }}</span><span *ngIf="formGroup.value.natchra === n._id"
                        class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- Gothram -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Gothram</label>
                <button type="button" (click)="toggleFilterDropdown('gothram', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="formGroup.value.gothram ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getSingleSelectLabel('gothram', 'Any Gothram') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'gothram'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'gothram'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['gothram'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div class="sticky top-0 bg-white z-10 pb-1.5 mb-1 border-b border-gray-100">
                    <input type="text" [(ngModel)]="singleSearchQuery" [ngModelOptions]="{standalone: true}"
                      placeholder="Search gothram..."
                      class="w-full px-2.5 py-1 rounded-lg border border-gray-200 text-xs bg-gray-50 focus:bg-white focus:outline-none focus:border-rose-400">
                  </div>
                  <div (click)="setSingleSelect('gothram', '')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="!formGroup.value.gothram ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any Gothram</span><span *ngIf="!formGroup.value.gothram"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <ng-container *ngFor="let g of gothrams">
                    <div
                      *ngIf="!singleSearchQuery || (g.gothram_nme || '')?.toLowerCase()?.includes(singleSearchQuery.toLowerCase())"
                      (click)="setSingleSelect('gothram', g._id)"
                      class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                      [ngClass]="formGroup.value.gothram === g._id ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                      <span>{{ g.gothram_nme }}</span><span *ngIf="formGroup.value.gothram === g._id"
                        class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- Dosham -->
              <div class="relative searchable-multi-select-container">
                <label class="block text-[10px] font-bold mb-1.5 uppercase tracking-wider"
                  style="color: #8c4458;">Dosham</label>
                <button type="button" (click)="toggleFilterDropdown('dosham', $event)"
                  class="w-full flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2 text-xs bg-white hover:border-gray-300 focus:outline-none transition-all cursor-pointer text-left shadow-sm">
                  <span class="truncate block pr-1"
                    [ngClass]="formGroup.value.dosham ? 'font-semibold text-rose-950' : 'text-gray-500'">{{
                    getSingleSelectLabel('dosham', 'Any') }}</span>
                  <span
                    class="material-symbols-outlined text-gray-500 text-[16px] transition-transform duration-200 flex-shrink-0"
                    [class.rotate-180]="activeDropdown === 'dosham'">expand_more</span>
                </button>
                <div *ngIf="activeDropdown === 'dosham'"
                  class="absolute z-[999] left-0 right-0 bg-white rounded-2xl border border-gray-200 shadow-2xl p-1.5 max-h-[220px] overflow-y-auto"
                  [ngClass]="dropdownDirection['dosham'] === 'up' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'">
                  <div (click)="setSingleSelect('dosham', '')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="!formGroup.value.dosham ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Any</span><span *ngIf="!formGroup.value.dosham"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <div (click)="setSingleSelect('dosham', 'Yes')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="formGroup.value.dosham === 'Yes' ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Yes (Dosham)</span><span *ngIf="formGroup.value.dosham === 'Yes'"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <div (click)="setSingleSelect('dosham', 'No')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="formGroup.value.dosham === 'No' ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>No Dosham</span><span *ngIf="formGroup.value.dosham === 'No'"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                  <div (click)="setSingleSelect('dosham', 'Don\'t Know')"
                    class="px-3 py-2 rounded-xl text-xs cursor-pointer flex items-center justify-between"
                    [ngClass]="formGroup.value.dosham === 'Don\'t Know' ? 'bg-rose-100/80 font-bold text-rose-950' : 'hover:bg-rose-50 text-gray-700'">
                    <span>Don't Know</span><span *ngIf="formGroup.value.dosham === 'Don\'t Know'"
                      class="material-symbols-outlined text-[14px] text-rose-700">check</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Filter Action Bar -->
          <div class="flex items-center justify-between px-5 py-3 border-t"
            style="border-color: rgba(176,30,62,0.08); background: #fdf8f9;">
            <span class="text-xs font-semibold flex items-center gap-1.5" style="color: #8c4458;">
              <span class="material-symbols-outlined text-[15px]">tune</span>
              {{ getActiveFilterCount() }} Active Filter{{ getActiveFilterCount() !== 1 ? 's' : '' }}
            </span>
            <div class="filter-actions flex items-center gap-2.5">
              <button type="button" (click)="resetFilters()"
                class="px-5 py-2 text-white rounded-xl text-xs font-bold shadow-sm transition-all border-0 flex items-center gap-1.5 cursor-pointer hover:opacity-90"
                style="background: #B01E3E;">
                <span class="material-symbols-outlined text-[16px]">restart_alt</span>
                Reset
              </button>
              <button *ngIf="!isFreePlan" type="button" (click)="openSaveFilterPopup()"
                class="px-5 py-2 text-white rounded-xl text-xs font-bold shadow-sm transition-all border-0 flex items-center gap-1.5 cursor-pointer hover:opacity-90"
                style="background: #B01E3E;">
                <span class="material-symbols-outlined text-[16px]">bookmark</span>
                Save Filter
              </button>
              <button *ngIf="isFreePlan" type="button" (click)="openSaveFilterPopup()"
                class="px-5 py-2 text-white rounded-xl text-xs font-bold shadow-sm transition-all border border-white/20 flex items-center gap-1.5 cursor-pointer hover:opacity-90"
                style="background: #B01E3E;">
                <span class="material-symbols-outlined text-[16px] text-white/80">lock</span>
                Save Filter <span
                  class="text-[9px] bg-white/20 text-white font-extrabold px-1.5 py-0.5 rounded tracking-wide ml-0.5">PRO</span>
              </button>
              <button type="button" (click)="applyFilter()"
                class="px-6 py-2 text-white rounded-xl text-xs font-bold shadow-sm transition-all border-0 flex items-center gap-1.5 cursor-pointer hover:opacity-90"
                style="background: #B01E3E;">
                <span class="material-symbols-outlined text-[16px]">search</span>
                Apply Filters
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- ── Guest Banner ──────────────────────────── -->
    <div class="rounded-2xl p-5 text-center border" *ngIf="!isLoggedIn"
      style="background: rgba(176,30,62,0.04); border-color: rgba(176,30,62,0.12);">
      <h2 class="font-display font-bold text-xl m-0 mb-1" style="color: #B01E3E;">Find Your Perfect Life Partner</h2>
      <p class="text-gray-500 text-xs m-0 mb-4">Sign up for FREE to view full profiles, contact matches, and start
        chatting today!</p>
      <button (click)="redirectToSignup()"
        class="px-6 py-2.5 rounded-xl text-white font-bold text-xs shadow-md transition-transform active:scale-95 border-0 cursor-pointer"
        style="background: #B01E3E;">Sign Up Free</button>
    </div>

    <!-- ── Results Section ────────────────────────── -->
    <section id="results-section" class="px-2 sm:px-4 lg:px-6">
      <!-- Results Heading -->
      <div class="section-header">
        <div>
          <h3>Search Results</h3>
          <p *ngIf="!loading">
            <strong class="text-gray-700">{{ filteredMatches.length }} {{ filteredMatches.length === 1 ? 'Profile' :
              'Profiles' }}</strong>
            found matching your filters
          </p>
        </div>
      </div>

      <!-- Profile Grid -->
      <div *ngIf="filteredMatches.length > 0; else noMatches" class="profile-grid">
        <div *ngFor="let profile of filteredMatches" class="pcard"
          [ngClass]="{'featured-vip-card': isFeaturedProfile(profile)}"
          [routerLink]="['/profile-details', profile._id]">

          <!-- Image -->
          <div class="pcard-img">
            <!-- ⭐ Refined Executive VIP Badge (top-right) -->
            <div *ngIf="isFeaturedProfile(profile)" class="vip-pill-badge">
              <span class="material-symbols-outlined">verified</span> VIP GOLD
            </div>

            <!-- ⭐ Broker Listed Badge -->
            <div *ngIf="profile.is_broker_profile && profile.claim_status !== 'claimed'" class="vip-pill-badge" style="background: #fff8e6; color: #b78103; border: 1px solid #ffeeba; top: 38px;">
              <span class="material-symbols-outlined" style="color: #b78103;">handshake</span> Broker Listed
            </div>

            <ng-container *ngIf="base64Images[profile._id]; else defaultAvatar">
              <img [src]="'data:image/jpeg;base64,' + base64Images[profile._id]" alt="Profile picture"
                [class.blur-md]="!isLoggedIn" />
            </ng-container>
            <ng-template #defaultAvatar>
              <div class="pcard-avatar-placeholder" [class.blur-sm]="!isLoggedIn">
                <span class="material-symbols-outlined text-[72px]" style="color: rgba(176,30,62,0.15);">person</span>
              </div>
            </ng-template>

            <!-- Gradient -->
            <div class="pcard-gradient"></div>

            <!-- Locked overlay for guests -->
            <div *ngIf="!isLoggedIn"
              class="absolute inset-0 flex flex-col items-center justify-center bg-black/35 backdrop-blur-[2px] z-20">
              <span class="material-symbols-outlined text-white text-[28px] mb-1 drop-shadow-md">lock</span>
              <span class="text-white font-bold text-[10px] tracking-wider uppercase">Preview Mode</span>
            </div>

            <!-- Favorite Button -->
            <button (click)="$event.stopPropagation(); isLoggedIn ? toggleFavorite(profile._id) : redirectToSignup()"
              class="pcard-fav-btn" [class.is-favorited]="isLoggedIn && isFavorite(profile._id)">
              <span class="material-symbols-outlined text-[15px]">favorite</span>
            </button>

            <!-- Match Badge Pill (top-left of image) -->
            <div *ngIf="profile.match_badge" class="pcard-match-badge" [ngClass]="{
                'badge-strong':  profile.match_badge === 'Strong Match',
                'badge-partial': profile.match_badge === 'Partial Match',
                'badge-similar': profile.match_badge === 'Similar Match',
                'badge-discover': profile.match_badge === 'Discover'
              }">
              <span class="material-symbols-outlined text-[11px]">
                {{ profile.match_badge === 'Strong Match' ? 'favorite' :
                profile.match_badge === 'Partial Match' ? 'thumb_up' :
                profile.match_badge === 'Similar Match' ? 'person_check' : 'explore' }}
              </span>
              {{ profile.match_badge }}
            </div>

            <!-- Name & Metadata Overlay -->
            <div class="pcard-overlay">
              <div class="flex items-center gap-1.5 mb-0.5">
                <h3 class="font-display text-[15px] font-bold m-0 truncate text-white drop-shadow-sm leading-tight">
                  {{ getMaskedName(profile) }}
                </h3>
                <span *ngIf="profile.verification_status === 'VERIFIED'" class="material-symbols-outlined fill-icon text-[14px] flex-shrink-0 drop-shadow text-white"
                  title="Verified Member">verified</span>
              </div>
              <div class="flex items-center gap-1.5 text-white/85 text-[11px] font-normal drop-shadow-sm truncate">
                <span>{{ getAge(profile.basic_info?.date_of_birth) ? getAge(profile.basic_info?.date_of_birth) + ' yrs'
                  : 'Age N/A' }}</span>
                <span class="opacity-40">·</span>
                <span class="truncate">{{ getLocationName(profile) || 'Location N/A' }}</span>
                <ng-container *ngIf="profile.horoscope_file_url">
                  <span class="opacity-40">·</span>
                  <span class="flex items-center gap-0.5 text-white flex-shrink-0 font-medium"
                    title="Horoscope Available">
                    <span class="material-symbols-outlined text-[11px]">auto_awesome</span>Horoscope
                  </span>
                </ng-container>
              </div>
            </div>
          </div>

          <!-- Info Chips -->
          <div class="info-chips">
            <span class="info-chip" title="Religion">
              <span class="material-symbols-outlined text-[12px]">temple_hindu</span>
              {{ getReligionName(profile) || 'Religion N/A' }}
            </span>
            <span class="info-chip" title="Education">
              <span class="material-symbols-outlined text-[12px]">school</span>
              {{ getEducationName(profile) || 'Education N/A' }}
            </span>
            <span class="info-chip" title="Occupation">
              <span class="material-symbols-outlined text-[12px]">work</span>
              {{ getOccupationName(profile) || 'Occupation N/A' }}
            </span>
          </div>

          <!-- Action Buttons -->
          <div class="pcard-actions">
            <a [routerLink]="['/profile-details', profile._id]" (click)="$event.stopPropagation()"
              class="btn-view">View</a>
            <button *ngIf="profile.interest_status === 'Pending'"
              (click)="$event.stopPropagation(); cancelInterest(profile)" title="Click to revert request"
              class="btn-pending group relative cursor-pointer hover:bg-red-50 hover:border-red-200 transition-all">
              <span class="flex items-center gap-1 group-hover:hidden">
                <span class="material-symbols-outlined text-[14px]">schedule</span>
                Awaiting
              </span>
              <span class="hidden group-hover:inline-flex items-center gap-1 text-red-600 font-bold">
                <span class="material-symbols-outlined text-[14px]">close</span> Cancel
              </span>
            </button>
            <a *ngIf="profile.interest_status === 'Accepted'" [routerLink]="['/chat']" [queryParams]="{ receiverId: profile._id }" (click)="$event.stopPropagation()" class="btn-chat no-underline">
              <span class="material-symbols-outlined text-[14px]">chat</span>
              Chat
            </a>
            <button *ngIf="!profile.interest_status"
              (click)="$event.stopPropagation(); isLoggedIn ? sendInterest(profile._id) : redirectToSignup()"
              class="btn-connect btn-ripple">
              <span class="material-symbols-outlined text-[14px] fill-icon">send</span>
              Connect
            </button>
          </div>
        </div>
      </div>

      <!-- No Results -->
      <ng-template #noMatches>
        <div class="bg-white rounded-[20px] p-14 text-center border border-[#EBEBEB] shadow-sm max-w-sm mx-auto mt-6">
          <div class="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
            style="background: #FFF0F4;">
            <span class="material-symbols-outlined text-3xl" style="color: #B01E3E;">search_off</span>
          </div>
          <h3 class="font-display font-bold text-lg text-gray-800 m-0">No Profiles Found</h3>
          <p class="text-gray-400 text-xs leading-relaxed mt-2 mb-5">
            Try relaxing your filters or resetting them to discover more matches.
          </p>
          <button (click)="resetFilters()" class="btn-connect btn-ripple px-6 border-0 cursor-pointer"
            style="flex: unset; padding: 10px 22px; border-radius: 12px;">
            Reset All Filters
          </button>
        </div>
      </ng-template>

    </section>

  </div>
</div>